(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);
  
    customElements.define('product-meta-loading', class extends baseComponent.default {
      
      render() {
        this.listenTo('variantLoading', () => {
            // Zeige Ladevorgang an
            this.setAttribute('active', '');
        });
        this.listenTo('variantChange', (e) => {
            // Entferne den Ladeindikator
            this.removeAttribute('active');
            
            // Greife auf das neue HTML zu, das vom variantChange-Event geliefert wurde
            // Annahme: e.detail.html ist ein DocumentFragment mit dem aktualisierten gesamten Bereich
            const newDoc = e.detail.html;
            const sectionId = this.getAttribute('section-id');
            const newMetaInner = newDoc.querySelector('#product-meta-inner-' + sectionId);
            
            if(newMetaInner) {
                // Finde den existierenden Container im aktuellen Dokument
                const currentMetaInner = document.getElementById('product-meta-inner-' + sectionId);
                if(currentMetaInner) {
                    // Ersetze den Inhalt
                    currentMetaInner.innerHTML = newMetaInner.innerHTML;
                }
            }
        });
      }
    });
})();